<template>

<div class="projects-wrapper" v-bind:style="{ height : windowHeight + 'px' }">

    <div class="project-frame"
            v-bind:style="{ height : windowHeight + 'px', width: windowWidth + 'px', left : sidebarWidth + 'px', top: windowMargin + 'px' }" 
        >

        <div class="projects-swipe-area text-center" 
            @click="handleDetectorClick" 
            v-touch:tap="handleDetectorClick"
            v-bind:style="{ height : layout.galleryHeight + 'px', width: windowWidth + 'px', left: layout.offsetLeft  + 'px', top : layout.offsetTop + 'px'  }" 
            v-touch:swipeleft="handleSwipe"
            v-touch:swiperight="handleSwipe"
            v-touch:swipeup="handleSwipe"
            v-touch:swipedown="handleSwipe"
            @scroll="handleDetector"
            @keyup.up=" preventArrowKeys"
            @keyup.down="preventArrowKeys"
            @keyup.left="preventArrowKeys"
            @keyup.right="preventArrowKeys"
            v-if="layout.type == 'small' || layout.type == 'medium'"
            > 
        </div>

        <div class="projects-detector" 
            @mousemove="handleMouseMove" 
            @click="handleDetectorClick" 
            id="swipe-detector" 
            v-bind:style="{ height : layout.galleryHeight  + 'px', width: viewportWidth  + 'px',  left: layout.offsetLeft + 'px' }" 
            @scroll="handleDetector"
            v-touch:swipeleft="handleSwipe"
            v-touch:swiperight="handleSwipe"
            v-touch:swipeup="handleSwipe"
            v-touch:swipedown="handleSwipe"
            v-if="layout.type == 'large'"
            @keyup.up="preventArrowKeys"
            @keyup.down="preventArrowKeys"
            @keyup.left="preventArrowKeys"
            @keyup.right="preventArrowKeys"
            > 
            <div class='detector-content' v-bind:style="{ height: 4000+ 'px', width: 4000 + 'px' }">
                &nbsp;
            </div>
        </div>
    </div>

    <div class="component-projects" v-bind:style="{ height : windowHeight + 'px' }" >
        <div class="projects-vertical-track" v-if="projectsVisible">
        <project-component :project="project" :index="index" @projectEnd='projectEnd' v-for="(project, index) in filteredProjects"></project-component>
            </div>
    </div>
</div>
</template>

<script>
import store from './store/store';
var Project = require('./project');

export default {

    components : { 'project-component' : Project},

     data () {
         return {
            title : '',
            testmsg : 'swipe',
            listen : true,
            thresholdX : 20,
            thresholdY :20,
            detectorOffsetY : 75,
            detectorOffsetX :75,
            lastMove : false
         }
     },

     computed : {

        projects()                  {return store.state.projects},
        projectsCurrentIndex()      { return store.state.projectsCurrentIndex; },
        projectsCurrentId()         { return store.state.projectsCurrentId; },
        sidebarWidth()              { return store.getters.getSidebarWidth },
        viewportWidth()             { return store.state.layout.viewportWidth },
        windowHeight()              { return store.state.layout.height; },
        windowWidth()               { return store.state.layout.width; },
        windowMargin()              { return store.getters.getWindowMargin },
        layout()                    { return store.state.layout; },
        windowRatio()               { return store.getters.getLayoutRatio },
        scroll()                    { return store.state.projectsScrollPosition; },
        pageMove()                  { return store.state.pageMove; },
        projectsVisible()           { return store.state.projectsVisible },
        categoryFilter()            { return store.state.categoryFilter },
        projectFrameHeight()        {
            
            if(this.windowMargin > 0) {
                return this.windowHeight - 2 * this.windowMargin ;
            }

            return this.windowHeight - 40;
        },
        filteredProjects()          { 
            return this.projects;

        },
     },

     watch : {
         projectsCurrentIndex : function(val, oldVal) {
                
             if(val > 0) {

                // only change sidebar status for large screen
                if(store.state.layout.type == 'large') {
                    store.commit('setSidebar', 1)
                }

             } else {

                 store.commit('setSidebar', 0)
             }
         },

         '$route' : function(val, oldVal) {
             this.checkAndScrollById(val.params.slug);
         },

         pageMove : function(val, oldVal) {
             console.log("Move page in projects " + val);

             if(val > 0) {
                this.nextPage(); 
             } else {

                this.prevPage(); 
             }
         },

         windowHeight : function(val, oldVal) {
            console.log("Fix scroll position for new window height");
            this.jumpToProject( this.projectsCurrentId );
         }


     },

    created : function() {

        this.$nextTick(function(){
             $("#swipe-detector").scrollTop(this.detectorOffsetY);
             $("#swipe-detector").scrollLeft(this.detectorOffsetX);
            });


          if(store.state.route.name == 'project' || store.state.route.name == 'project-slide') {
              console.log("Jump tp " + store.state.route.params.slug);
              this.jumpToProject( store.state.route.params.slug );
          };
          if(store.state.route.name == 'projects') {
               this.title = "Start with project 1"; 
          };
          if(store.state.route.name == 'start') {
               this.title = "Start"; 
          }

    },

    methods : {

            preventArrowKeys : function(event) {

                console.log("Prevent arrow keys");
                return false;
            },

            handleSwipe : function(event) {

                if(!this.listen ) {  return false; }

                this.testmsg = "Detected " + event.type;

                if(event.type === 'swipeleft') {
                    this.nextSlide();
                }
                if(event.type === 'swiperight') {
                    this.prevSlide();
                }
                if(event.type === 'swipeup') {
                    this.nextPage();
                }
                if(event.type === 'swipedown') {
                    this.prevPage();
                }
            },

        handleDetector : function(event) {

            // return false on small screens
            /* if(this.windowWidth < 500) { return false; } */

            // are we currently listening to the scroll event?
            if(!this.listen ) { this.startDetector(); return false; }

            // Get delta
            var deltaY = event.target.scrollTop - this.detectorOffsetY;
            var deltaX = event.target.scrollLeft - this.detectorOffsetX;

            // do we want to move at all?
            if(deltaY == deltaX || ( Math.abs(deltaY) < this.thresholdY && Math.abs(deltaX) < this.thresholdX)) { this.startDetector(); return false; }
            

            // what is the dominant direction?
            if(Math.abs( deltaY ) > Math.abs( deltaX )) {
                // next page
                if(event.target.scrollTop > this.detectorOffsetY) { 
                    this.nextPage();
                } 
                // prev page
                else {
                    this.prevPage();
                }
            } else {

                // next slide
                if(event.target.scrollLeft > this.detectorOffsetX) { 
                    this.nextSlide();
                    console.log("move right"); 
                } 
                // prev slide
                else {
                    this.prevSlide();
                    console.log("Move left");
                }
            }

        },

        handleMouseMove : function(event) {
         
            // get coordinate
            var x = event.clientX;
            var y = event.clientY;
            var direction = this.getDirectionFromCoordinates(x,y);

            $('.projects-detector')
                .removeClass('left right up down')
                .addClass(direction);

            // calculate squares
        },

        handleDetectorClick : function(event) {

            var x = event.clientX;
            var y = event.clientY;
            var direction = this.getDirectionFromCoordinates(x,y);

            switch(direction) {
                case 'up': 
                    this.prevPage();
                    break;
                case 'down': 
                    this.nextPage();
                    break;
                case 'right': 
                    this.nextSlide();
                    break;
                case 'left': 
                    this.prevSlide();
                    break;

            }

            console.log(direction);


        },


        getDirectionFromCoordinates : function(x,y)  {
            var direction = false;

            var l = 0.3;
            var r = 0.3;
            var u = 0.2;
            var d = 0.80; 
            

            if(x <= this.windowWidth * l) { direction = 'left'; } 
            if(x > this.windowWidth * l) { direction = 'right'; } 
            if(y < this.windowHeight * u) { direction = 'up'; } 
            if(y > this.windowHeight * d) { direction = 'down'; } 

            return direction;
        },


        nextPage : function() {

             // can we move any further?
             var scrollPosition = $(".projects-vertical-track").css('marginTop');

             console.log("move next " + parseInt(scrollPosition) + ' ' + ( this.filteredProjects.length -1 ) * this.windowHeight);

             if(parseInt(scrollPosition) - this.windowHeight < -1 * ( this.filteredProjects.length -1 ) * this.windowHeight) {
                 console.log('Last page reeached');
                 this.listen = true;
                 this.startDetector();
                 return false;
             }

            if(this.lastMove - Date.now() > -400) {  
                console.log('To early to move on');
                this.listen = true;  
                this.startDetector(); 
                return false; 
            }
             
             if(!this.listen ) { return false; }


             this.listen = false;
             // this.resetDetector();

             $('.projects-vertical-track').velocity(
                 {marginTop : "+=" +  -1* this.windowHeight + 'px'},  
                 { easing : 'easeOutQuint', duration : 800, complete: this.resetDetector.bind(this) }
             );
        },

        checkAndScrollById : function(id) {
           console.log("check and scroll by id") ;
           this.jumpToProject(id);
        },

        prevPage : function() {

             // can we move any further?
             var scrollPosition = $(".projects-vertical-track").css('marginTop');
             if(parseInt(scrollPosition) + this.windowHeight > 0 ) {
                 console.log("First page reached");
                 this.listen = true;
                 this.startDetector();
                 return false;
             }
            
             if(this.lastMove - Date.now() > -300) {  this.listen = true; this.startDetector(); return false; }
            
             if(!this.listen ) { this.startDetector(); this.listen = true; return false; }


             this.listen = false;
             // this.resetDetector();
             $('.projects-vertical-track').velocity(
                 {marginTop : "+=" +  1* this.windowHeight + 'px'} ,
                 { easing : 'easeOutQuint', duration : 800, complete : this.resetDetector.bind(this) }
             );
        },

        nextSlide : function() {

            if(this.projectsCurrentIndex < 1) {
               console.log("Move down");
               this.nextPage();
               return false;
            }

            store.commit('setProjectMove', 1);
            this.resetDetector();
        },

        prevSlide : function() {

            if(this.projectsCurrentIndex < 1) {
               console.log("Move down");
               this.nextPage();

               return false;
            }

            store.commit('setProjectMove', -1);
            this.resetDetector();
        },

        resetDetector : function() {

            this.lastMove = Date.now();
            var scrollPosition = $(".projects-vertical-track").css('marginTop');
            
            store.commit('setProjectsScrollPosition', parseInt( scrollPosition ));

             $("#swipe-detector").scrollTop(this.detectorOffsetY);
             $("#swipe-detector").scrollLeft(this.detectorOffsetX);
             console.log("Reset scroll detector now");

             this.listen = true; 

        },

        startDetector : function() {

             $("#swipe-detector").scrollTop(this.detectorOffsetY);
             $("#swipe-detector").scrollLeft(this.detectorOffsetX);
        },

        jumpToProject : function(id) {
            
            var project = this.getProjectById(id);
            var index = this.filteredProjects.indexOf(project);
            console.log("Render after jumping to Project index " + index + ' of project' + project.id);

           this.$nextTick(function(){
                 store.commit('setProjectRerender');
                 $("#swipe-detector").scrollTop(this.detectorOffsetY);
                 $("#swipe-detector").scrollLeft(this.detectorOffsetX);

                 console.log("scroll to requested project");

                 $('.projects-vertical-track').velocity(
                     {marginTop : -1* this.windowHeight * index + 'px'} ,
                     { easing : 'easeOutQuint', duration : 1, complete : this.handleJumpCompleted.bind(this) }

             );

                });

        },

        handleJumpCompleted : function() {
            this.resetDetector();
            store.commit('setProjectsVisible', true);
        },

        getScrollPositionById : function(id) {
            
        },

        getProjectById : function(id) {

            for (var i = 0; i< this.filteredProjects.length; i++) {

                if( this.filteredProjects[i].id == id ) {
                    return this.filteredProjects[i];
                }
            }
            
        },

        projectEnd : function() {

            console.log('project says end');
            this.lastMove = Date.now() - 400;
            this.nextPage();
        },


        test : function(e) {


            this.testmsg = e.type;

        }


    }


}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// projects.vue?37de52b7